export default function WebIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.34191 10H13.6584M2.34167 6H13.6582M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM10.5 8C10.5 11.2248 9.38071 13.8389 8 13.8389C6.61929 13.8389 5.5 11.2248 5.5 8C5.5 4.77525 6.61929 2.16107 8 2.16107C9.38071 2.16107 10.5 4.77525 10.5 8Z"
          stroke="#820BF4"
          stroke-width="1.25"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
}
